'use memo';

import type { PropsWithChildren, ReactNode } from 'react';
import HelpHoverCard from '@/components/Card/HelpHoverCard';
import { StatCard, StatCardTitle } from '@/components/Card/StatCard';
import { HStack } from '@/components/Layout';
import { Text } from '@/components/Typography';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/cn';

/**
 * 「もっとみる」導線。メンバー概要に倣い mutedGhost ボタンで表示する。
 * ルートごとの型付き Link を `children` に渡して使う。
 */
export function SeeMoreButton({
  children
}: PropsWithChildren) {
  return <Button asChild variant="mutedGhost" size="sm" className="-mr-2">
      {children}
    </Button>;
}
type BentoCardProps = PropsWithChildren<{
  title: string;
  /** タイトル横のヘルプ（`?`アイコンにホバーで表示）。カウント方法の説明等に使う */
  help?: string;
  /** ヘッダー右側に置く要素（もっとみるボタンやサブタイトル） */
  headerRight?: ReactNode;
  className?: string;
}>;

/**
 * Overview のタイル1枚分のカードシェル。
 * メンバー概要に倣い共通 StatCard / StatCardTitle を使う（独自シャドー・角丸は持たない）。
 */
export function BentoCard({
  title,
  help,
  headerRight,
  className,
  children
}: BentoCardProps) {
  return <StatCard className={cn('flex flex-col', className)}>
      <HStack className="min-h-8 items-center justify-between gap-2">
        <HStack className="items-center gap-1">
          <StatCardTitle>{title}</StatCardTitle>
          {help ? <HelpHoverCard side="top">
              <Text variant="pSmall">{help}</Text>
            </HelpHoverCard> : null}
        </HStack>
        {headerRight}
      </HStack>
      {children}
    </StatCard>;
}